export default "__VITE_ASSET__BmNlDWLf__"